import { lazy } from 'react';

import { ALLOWED_ROLES, REMOTE_CONFIG_KEYS, withRemoteConfigKey } from '../utils';

import { PATHS } from './constants';

const DocumentRequestList = lazy(() => import('./screens/DocumentRequestList'));

const documentRequestsRoutes = [
  {
    component: DocumentRequestList,
    path: PATHS.BASE_URL,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DOCUMENT_REQUESTS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default withRemoteConfigKey(REMOTE_CONFIG_KEYS.TIME_TRACKER, documentRequestsRoutes);
